// extracted by mini-css-extract-plugin
export default {"file-hash":"MGn4ayFi6Z3kBuMafouQ","hash":"xjO1DgYn8h1xYqGsKSuN"};